/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"

import { Container, Row, Col, Button, Table } from "react-bootstrap"
import ComboBox from "../../../../components/ComboBox"
import { TWijmoComboBox } from "../../../../type/wijmoComponents"
import { useEffect, useState } from "react"
import TextInput from "../../../../components/InputWrapper/TextInput"
import { T表紙分割 } from "../../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"

import { Form } from "react-bootstrap"
import Spinner from "../../../../components/Spinner"

import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import {
  TZyutyuHaisyaPatternListGetReq,
  TZyutyuHaisyaPatternListGetRes,
} from "../../../../service/order/zyutyuHaisyaPattern/TZyutyuHaisyaPattern"
import ZyutyuHaisyaPatternService from "../../../../service/order/zyutyuHaisyaPattern/zyutyuHaisyaPatternService"
import { ZyutyuHaisyaPatternListProvider } from "./ZyutyuHaisyaPatternModalContext"
import ZyutyuHaisyaPatternModalGrid from "./ZyutyuHaisyaPatternModalGrid"
import LocalAlertComponent from "../../../../components/LocalAlertComponent"
import NinusiService from "../../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"
import { T部所マスタ } from "../../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../../service/master/busyo/busyoService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { setAlerts } from "../../../../globalStore/alertStore"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."

// TODO:型定義は別枠に

export type T受注配車パターン入力GridItem = TZyutyuHaisyaPatternListGetRes & {
  受注No?: string
  date請求計上日?: Date
  date支払計上日?: Date
  積地id?: number
  積地社名?: string
  積地都道府県?: string
  積地市区町村?: string
  卸地id?: number
  卸地社名?: string
  卸地都道府県?: string
  卸地市区町村?: string
  品コード?: string
  品名?: string
  数量?: string
  単位区分コード?: string
  受注配車パターンコード?: string
  積地数?: number
  卸地数?: number
  品数?: number
}

/**
 * 受注配車パターン入力モーダル
 * @returns
 */
const ZyutyuHaisyaPatternModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    ninusiCode?: string
    ninusiName?: string
    zyutyubusyo?: T部所マスタ
    setPattern: (value: TZyutyuHaisyaPatternListGetRes) => unknown
  }
> = (props) => {
  //TODO:ページ名称確定必須
  let gridId = "ZyutyuHaisyaPtnMdl_GridId"

  //#region [state]
  const dispatch: AppDispatch = useDispatch()

  // 画面共通
  const [isSearching, setIsSearching] = useState(false)

  const [searchResult, setSearchResult] =
    useState<TZyutyuHaisyaPatternListGetRes[]>()

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  //1列目
  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  //2列目

  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()

  const [荷主請求ID, set荷主請求ID] = useState<number | null>()
  const [表紙分割ItemSource, set表紙分割ItemSource] = useState<T表紙分割[]>()

  const [荷主請求内訳ID, set荷主請求内訳ID] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()

  const [品コード, set品コード] = useState<string>()
  const [品名, set品名] = useState<string>()

  //3列目
  const [受注配車パターンコード, set受注配車パターンコード] =
    useState<string>("")
  const [車番, set車番] = useState<string>()
  const [乗務員, set乗務員] = useState<string>()

  //4列目
  const [積地地名, set積地地名] = useState<string>()
  const [積地社名, set積地社名] = useState<string>()

  const [卸地地名, set卸地地名] = useState<string>()
  const [卸地社名, set卸地社名] = useState<string>()

  //#endregion

  //#region [comboboxState]

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)

  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set受注部所コード(props.zyutyubusyo?.部所コード ?? "")
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (!gridInitialized) return

    if (props.isShow) {
      setAlertSource(undefined)
      //表示時
      set荷主コード(props.ninusiCode)
      set荷主名(props.ninusiName)
      set受注部所コード(props.zyutyubusyo?.部所コード ?? "")
      // 荷主コードが設定されている場合、その荷主コードで検索
      if (
        !wjcCore.isNullOrWhiteSpace(props.ninusiCode ?? "") ||
        !wjcCore.isNullOrWhiteSpace(props.ninusiName ?? "")
      ) {
        search({
          荷主コード: props.ninusiCode ?? "",
          受注部所コード: props.zyutyubusyo?.部所コード ?? "",
        })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set荷主コード("")
      set荷主名("")
      set荷主請求ID(null)
      set表紙分割ItemSource([])
      set荷主請求内訳ID(null)
      set請求内訳ItemSource([])
      set品コード("")
      set品名("")
      set受注配車パターンコード("")
      set車番("")
      set乗務員("")
      set積地地名("")
      set積地社名("")
      set卸地地名("")
      set卸地社名("")
      setSearchResult([])
    }
  }, [props.isShow, gridInitialized])

  //#endregion

  //#region [method]

  /**
   * 検索
   */
  const search = async (searchCondition?: TZyutyuHaisyaPatternListGetReq) => {
    setIsSearching(true)
    setAlertSource(undefined)

    let currentSearchCondition
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    // TODO:検索処理導入
    try {
      const service = new ZyutyuHaisyaPatternService()

      const res = await service.getList(currentSearchCondition)
      setSearchResult(res.data)
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (): TZyutyuHaisyaPatternListGetReq => {
    return {
      荷主コード: 荷主コード ?? "",
      荷主名: 荷主名 ?? "",
      // 画面より確定で取得する
      受注部所コード: 受注部所コード ?? "",
      荷主請求ID: !荷主請求ID ? undefined : 荷主請求ID,
      荷主請求内訳ID: !荷主請求内訳ID ? undefined : 荷主請求内訳ID,
      受注配車パターンコード: 受注配車パターンコード ?? "",
      品コード,
      品名,
      積地社名,
      積地地名,
      卸地社名,
      卸地地名,
      車番,
      乗務員,
    }
  }
  /**
   *
   * @param 荷主コード
   * @returns
   */
  const set表紙 = async (荷主コード: string) => {
    try {
      if (荷主コード == null || 荷主コード === "") {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主res = await new NinusiService().getList({
        荷主コード: 荷主コード !== "" ? 荷主コード : undefined,
        完全一致フラグ: true,
      })
      if (荷主res.data == null || 荷主res.data.length <= 0) {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主 = 荷主res.data[0]
      set荷主コード(荷主.荷主コード)
      set荷主名(荷主.荷主略称1)
      if (荷主 != null) {
        const ninusiSeikyuService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiSeikyuService.getList({
          荷主Id: 荷主.荷主ID,
        })
        if (荷主請求res && 荷主請求res.data.length > 0) {
          set表紙分割ItemSource([...荷主請求res.data])
          set請求内訳ItemSource([])
        } else {
          set表紙分割ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }
  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={"受注配車パターン検索"}
      setIsShow={props.setIsShow}
      dialogClassName="mw-80"
      footer={props.footer}>
      <Spinner inModal searching={isSearching}></Spinner>
      <Container fluid>
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form>
              <Container fluid className="contents-search-main">
                <Row>
                  <Col>
                    <div className="search-condition-table">
                      <div className="search-condition-row">
                        {props.zyutyubusyo ? (
                          <Table className="form-table">
                            <tbody>
                              <tr>
                                <th className="min-w-8rem">部所</th>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    width: "20rem",
                                  }}>
                                  <span>
                                    {props.zyutyubusyo.部所コード} :{" "}
                                    {props.zyutyubusyo.部所略称}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        ) : (
                          <ComboBox.Busyo
                            placeholder="受注部所"
                            isLoadEnded={受注部所isLoadEnded}
                            setIsLoadEnded={set受注部所isLoadEnded}
                            isAllSelect={false}
                            isRequired={true}
                            itemsSource={部所ItemSource}
                            selectedValue={受注部所コード}
                            listFilter={(d) => d.運行部所フラグ === 1}
                            setSelectedValue={(v) => {
                              set受注部所コード(v)
                            }}
                            ComboBox={受注部所ComboBox}
                            setComboBox={set受注部所ComboBox}></ComboBox.Busyo>
                        )}
                      </div>
                      <div className="search-condition-row">
                        <div className="input-group">
                          <TextInput
                            style={{ width: "6rem" }}
                            id="荷主コード"
                            autoFocus={true}
                            name="荷主コード"
                            value={荷主コード}
                            setValue={async (v) => {
                              set荷主コード(v)
                            }}
                            onBlur={async (e) => {
                              const v = e.currentTarget.value
                              set表紙(v)
                            }}
                            maxLength={5}
                            placeholder="荷主CD"
                          />
                          <TextInput
                            style={{ width: "25rem" }}
                            id="荷主名"
                            name="荷主名"
                            value={荷主名}
                            setValue={set荷主名}
                            maxLength={100}
                            placeholder="荷主名"
                          />
                        </div>
                        <ComboBox.HyosiBunkatu
                          isAllSelect={true}
                          placeholder="表紙名"
                          isReadOnly={
                            表紙分割ItemSource == null ||
                            表紙分割ItemSource.length <= 0
                              ? true
                              : false
                          }
                          itemsSource={表紙分割ItemSource}
                          isLoadEnded={表紙分割IsLoadEnded}
                          setIsLoadEnded={set表紙分割IsLoadEnded}
                          setSelectedValue={(v) => {
                            set荷主請求ID(v)
                            if (v == null) return
                            const ninusiSeikyuService =
                              new NinusiSeikyuService()
                            ninusiSeikyuService
                              .getListUchiwake({
                                荷主請求Id: v,
                              })
                              .then((res) => {
                                res.data && set請求内訳ItemSource([...res.data])
                              })
                          }}
                          selectedValue={荷主請求ID}
                          ComboBox={表紙分割ComboBox}
                          setComboBox={
                            set表紙分割ComboBox
                          }></ComboBox.HyosiBunkatu>
                        <div className="input-group">
                          <TextInput
                            id="積地"
                            name="積地社名"
                            value={積地社名}
                            setValue={set積地社名}
                            maxLength={100}
                            placeholder="積地社名"
                          />
                          <TextInput
                            id="積地"
                            name="積地地名"
                            value={積地地名}
                            setValue={set積地地名}
                            maxLength={100}
                            placeholder="積地地名"
                          />
                        </div>
                        <div>
                          <TextInput
                            id="受注配車パターンコード"
                            name="受注配車パターンコード"
                            value={受注配車パターンコード}
                            setValue={set受注配車パターンコード}
                            maxLength={20}
                            placeholder="パターンコード"
                          />
                        </div>
                      </div>
                      <div className="search-condition-row">
                        <div className="input-group">
                          <TextInput
                            style={{ width: "6rem" }}
                            id="品コード"
                            name="品コード"
                            value={品コード}
                            setValue={(v) => {
                              set品コード(v)
                            }}
                            maxLength={5}
                            placeholder="品CD"
                          />
                          <TextInput
                            style={{ width: "25rem" }}
                            id="品名"
                            name="品名"
                            value={品名}
                            setValue={set品名}
                            maxLength={100}
                            placeholder="品名"
                          />
                        </div>
                        <ComboBox.SeikyuUtiwake
                          placeholder="請求内訳"
                          isReadOnly={
                            請求内訳ItemSource == null ||
                            請求内訳ItemSource.length <= 0
                              ? true
                              : false
                          }
                          itemsSource={請求内訳ItemSource}
                          isLoadEnded={請求内訳IsLoadEnded}
                          setIsLoadEnded={set請求内訳IsLoadEnded}
                          setSelectedValue={(v) => {
                            set荷主請求内訳ID(v)
                          }}
                          selectedValue={荷主請求内訳ID}
                          ComboBox={請求内訳ComboBox}
                          setComboBox={
                            set請求内訳ComboBox
                          }></ComboBox.SeikyuUtiwake>
                        <div className="input-group">
                          <TextInput
                            id="卸地"
                            name="卸地社名"
                            value={卸地社名}
                            setValue={set卸地社名}
                            maxLength={100}
                            placeholder="卸地社名"
                          />
                          <TextInput
                            id="卸地"
                            name="卸地地名"
                            value={卸地地名}
                            setValue={set卸地地名}
                            maxLength={100}
                            placeholder="卸地地名"
                          />
                        </div>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "5rem" }}
                            id="車番"
                            name="車番"
                            value={車番}
                            setValue={set車番}
                            maxLength={100}
                            placeholder="車番"
                          />
                          <TextInput
                            id="乗務員"
                            name="乗務員"
                            value={乗務員}
                            setValue={set乗務員}
                            maxLength={100}
                            placeholder="乗務員"
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end">
                    <Button
                      type="submit"
                      disabled={isSearching}
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        search()
                      }}>
                      <FontAwesomeIcon icon={faSearch} />
                      検索
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <div className="mt-2">
              <ZyutyuHaisyaPatternListProvider
                isSearching={{ state: isSearching, setState: setIsSearching }}
                SearchResult={searchResult}
                gridInitialized={{
                  state: gridInitialized,
                  setState: setGridInitialized,
                }}>
                <ZyutyuHaisyaPatternModalGrid
                  setPattern={(v) => {
                    props.setPattern(v)
                    props.setIsShow(false)
                  }}
                  gridId={gridId}></ZyutyuHaisyaPatternModalGrid>
              </ZyutyuHaisyaPatternListProvider>
            </div>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default ZyutyuHaisyaPatternModal
